module.exports = __webpack_public_path__ + "static/img/PSS-50A.c9b8d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSS-50A.png
// module id = nzv6
// module chunks = 1